export default __webpack_public_path__ + "static/media/threebigcards_retail_3.ea0b70ca.png";